import React, { memo } from "react";

import AccountsPayableReceivableReport from "../AccountsPayableReceivableReport";

const AccountPayableReport = () => {
  return <AccountsPayableReceivableReport accountCode="2400" />;
};

export default memo(AccountPayableReport);
